import React from "react";
import { Tooltip } from "antd";
import { infoIcon, viewIcon } from "../../Icons/Icons";
import moment from "moment";
const LeavePercentage = ({ leavedata }) => {
  const leaveName = leavedata.leave_name;
  const isLopLeaveType = leavedata.is_lop;
  const listIsExpiryActive = leavedata?.is_expiry_active;
  const leaveBalanceDays = leavedata?.leave_balance_days || 0;
  const leaveBalanceHours = leavedata?.leave_balance_hours || 0;
  const expiryList = Array.isArray(leavedata.expiryList) ? leavedata.expiryList : [];

  /*  VIEW ICON  */
 const ExpiryTooltipContent = () => {
  if (!expiryList.length) {
    return (
      <div className="text-sm text-gray-700">
        Leave balance will be updated once approved.
      </div>
    );
  }

  return (
    <div className="max-h-40 overflow-y-auto border border-gray-300 rounded-md">
      <table className="w-full text-sm border-collapse">
        <thead>
          <tr className="bg-gray-100">
            <th className="px-3 py-2 border whitespace-nowrap">
              Approved Date
            </th>
            <th className="px-3 py-2 border whitespace-nowrap">
              Expiry Date
            </th>
            <th className="px-3 py-2 border whitespace-nowrap">
              Available Balance
            </th>
          </tr>
        </thead>

        <tbody>
          {expiryList.map((item, index) => (
            <tr key={index}>
              <td className="px-3 py-2 border text-center whitespace-nowrap">
                {moment(item.created_at).format("DD-MM-YYYY")}
              </td>
              <td className="px-3 py-2 border text-center whitespace-nowrap">
                {moment(item.expiry_date).format("DD-MM-YYYY")}
              </td>
              <td className="px-3 py-2 border text-center whitespace-nowrap">
                {item?.status === 3
                  ? "Expired"
                  : `${item?.available_balance} day(s)`}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

  /*  BALANCE INFO */
  const availableBalance = (
    <div className="text-center text-lg">
      <span>
        <strong>{leaveBalanceDays}</strong>{" "}
        <span className="text-sm">days</span>
      </span>
      {leaveBalanceHours > 0 && (
        <>
          <br />
          <span>
            <strong>{leaveBalanceHours}</strong>{" "}
            <span className="text-sm">hours</span>
          </span>
        </>
      )}
    </div>
  );

  /*  TOOL TIP INFO  */
  const maxDaysCanBeAccumulated = leavedata?.max_limit_can_be_accumulated || 0;
  const numberOfDaysAllowed = leavedata?.number_days_allowed || 0;

  let description = leavedata?.description || "";
  description += `
    <br/>
    <div style="display:flex;flex-direction:column;gap:.5rem;
         border:1px solid #a8aaad;padding:.5rem;border-radius:.5rem;">
      <div style="display:flex;justify-content:space-between;">
        <span>Maximum days can be accumulated:</span>
        <strong>${maxDaysCanBeAccumulated}</strong>
      </div>
      <div style="display:flex;justify-content:space-between;">
        <span>Total leave allocated:</span>
        <strong>${numberOfDaysAllowed}</strong>
      </div>
    </div>
  `;

  const bookedDays = leavedata?.booked_day || 0;
  const bookedHours = leavedata?.booked_hours || 0;
  const booked = `${bookedDays} days${
    bookedHours ? ` ${bookedHours} hours` : ""
  }`;

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h3 className="font-semibold text-gray-800">{leaveName}</h3>

        <div className="flex gap-2 items-center">
          <Tooltip
            title={<div dangerouslySetInnerHTML={{ __html: description }} />}
            color="geekblue"
            trigger="click"
          >
            <span className="cursor-pointer">{infoIcon}</span>
          </Tooltip>

          {listIsExpiryActive && (
            <Tooltip
              overlayStyle={{ maxWidth: "none" }}
              title={
                <div className="w-[420px] p-2 ">
                  <ExpiryTooltipContent />
                </div>
              }
              color="blue"
              trigger="click"
            >
              <span className="cursor-pointer">{viewIcon}</span>
            </Tooltip>
          )}
        </div>
      </div>

      {!isLopLeaveType && (
        <div className="flex justify-between text-sm text-gray-500">
          <span>Available Balance:</span>
          <span className="font-medium text-gray-800">{availableBalance}</span>
        </div>
      )}

      <div className="mt-2 flex justify-between text-sm text-gray-500">
        <span>Booked:</span>
        <span className="text-gray-900">{booked}</span>
      </div>
    </div>
  );
};

export default LeavePercentage;
